import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { ReportCatalogItem, ReportExportToken, ReportResponse } from './report-catalog'

export class ReportCatalogRepository extends BaseRepository<ReportCatalogItem> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.zanduApiUrl + '/' + 'reports', token, cache)
    }

    // endpoint vem do próprio catálogo (ReportCatalogItem.endpoint) — cada relatório migrado pro backend
    // tem sua própria rota, então essa chamada não é um CRUD fixo como os métodos herdados de BaseRepository
    async run(endpoint: string, params?: any): Promise<ReportResponse> {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.config.zanduApiUrl + endpoint + queryString + 'token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // token de exportação (escopo: empresa inteira, qualquer relatório, sem expiração) — usado pra montar
    // o link de CSV colável num =IMPORTDATA(...) do Sheets ou no Power Query do Excel. reportId/params
    // são só pra montar o link curto (shortUrl) desta consulta específica — o token em si continua
    // valendo pra qualquer relatório se a URL de CSV for montada manualmente. locale controla o formato
    // de saída do CSV (delimitador/decimal), não é parâmetro de negócio do relatório.
    async createExportToken(reportId?: string, params?: Record<string, any>, locale?: 'pt-BR' | 'en-US'): Promise<ReportExportToken> {
        const url = this.config.zanduApiUrl + '/reports/export-token?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.post(url, { reportId, params, locale })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // monta a URL pública de export CSV — reflete exatamente os params do relatório atual (ReportResponse.params),
    // sem exigir token de sessão: só o token de exportação (?t=), validado pelo hub de links públicos
    buildCsvUrl(reportId: string, params: Record<string, any>, exportToken: string): string {
        let queryString = 't=' + encodeURIComponent(exportToken)
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                queryString += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            }
        }
        return this.config.zanduApiUrl + '/reports/' + reportId + '/csv?' + queryString
    }
}
